module.exports = __webpack_public_path__ + "static/media/200d.8532155e.jpg";